import Log from '../../../../utils/log.js';
import { isObjectItem, isSelectListItem } from './common.js';

function getItemId(item, itemKeyProperty) {
    if (isObjectItem(item)) {
        const key = itemKeyProperty ? item[itemKeyProperty] : undefined;
        if (key === undefined) {
            Log.warn('La proprietà dell\'item è undefined');
        }
        return key;
    }
    return item;
}
function isDisabled(item) {
    if (isSelectListItem(item)) {
        return item.disabled;
    }
    return false;
}
function isUpdateEnabled(item) {
    if (!isSelectListItem(item))
        return false;
    return item.enableUpdate;
}

export { getItemId, isDisabled, isUpdateEnabled };
